import React, { useEffect, useState } from "react";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import { useGetNewsQuery as getAdminNews } from "../../api/admin/newsApi";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { renderText } from "../../../utils/functions/textFormatter";
import { Divider } from "@mui/material";
import CorePagination from "../../../app/core/components/CorePagination/CorePagination";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
import LockScreen from "../../../app/core/components/CoreLockScreen/LockScreen";
import { ROLE } from "../../../utils/constants/profiles";
import { useSelector } from "react-redux";
import { useGetNewsQuery as getUserNews } from "../../api/user/newsApi";

const NewsPage = () => {
  const navigate = useNavigate();
  const role = useSelector((state) => state.app.role);
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });
  const [news, setNews] = useState([]);

  const {
    data: adminData,
    isLoading: adminIsLoading,
    refetch: adminRefetch,
  } = getAdminNews({ page }, { skip: ROLE.USER === role });

  const {
    data: userData,
    isLoading: userIsLoading,
    refetch: userRefetch,
  } = getUserNews(null, { skip: ROLE.USER !== role });

  useEffect(() => {
    if (
      ROLE.USER !== role &&
      adminData &&
      adminData.Data &&
      adminData.Data.items
    ) {
      setNews(adminData.Data.items);
    }
    if (ROLE.USER === role && userData && userData.Data) {
      setNews(userData.Data);
    }
  }, [adminData, userData, role]);

  const handleDetail = (singleNews) => {
    navigate(t("news"), { state: { ...singleNews } });
  };

  const handleRefecthDocuments = () => {
    if (ROLE.USER !== role) adminRefetch();
    if (ROLE.USER === role) userRefetch();
  };

  if (adminIsLoading || userIsLoading) {
    return <CoreSpinner />;
  }

  return (
    <div className="w-full">
      {ROLE.USER === role && (
        <LockScreen
          text={`${t("NotAlreadyAssociated")}`}
          cta={() => navigate(`/auth/user/associa-${t("studio")}`)}
        />
      )}
      <div className="flex">
        <h2>{t("News")}</h2>
      </div>
      <div className="py-2">
        <CoreButtonHoverIcon
          onClick={handleRefecthDocuments}
          className="text-blue-500 m-1 flex flex-row space-x-2 border"
          testo={t("Refresh")}
          icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
        />
      </div>
      {news.length === 0 && (
        <div className={"my-5"}>
          <p className="text-gray">{t("NoNewsYet")}</p>
        </div>
      )}
      {news?.map((news) => (
        <>
          <div className="flex py-8 items-center space-x-12" key={news.id}>
            <div className="flex w-28 h-28 items-center">
              <img
                src={
                  news.imageUrl ? news.imageUrl : "/img/placeholder-image.svg"
                }
                alt="Immagine"
                style={{
                  width: "100%",
                  height: "auto",
                }}
              />
            </div>
            <div className="w-9/12">
              <h3 className="m-0">{news.title}</h3>
              <p className="m-0">{renderText(news.text)}</p>
            </div>
            <CoreButton
              testo={t("Visualize")}
              className={"btn-round"}
              onClick={() => handleDetail(news)}
            />
          </div>
          <Divider />
        </>
      ))}
      <div className="w-full flex justify-center">
        {ROLE.USER !== role && (
          <CorePagination
            page={page}
            setPage={setPage}
            totalPages={
              Math.ceil(adminData?.Data?.count / TABLE_ROWS_NUMBER) || 1
            }
          />
        )}
      </div>
    </div>
  );
};

export default NewsPage;
